<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-success m-2" @click="newClicked">+ سند ادغام جدید</button>
            </div>
            <div class="col-12">
                <div class="table-responsive" v-if="vouchers !== undefined && vouchers.length>0">
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th class="text-center text-nowrap">شماره سند ادغام</th>
                            <th class="text-center text-nowrap">تعداد اسناد</th>
                            <th class="text-center text-nowrap">تاریخ</th>
                            <th class="text-center text-nowrap">کاربر</th>
                            <th class="text-center text-nowrap">شماره فاکتور</th>
                            <!--<th class="text-center text-nowrap">توضیحات</th>-->
                            <!--<th class="text-center text-nowrap">مبلغ کل</th>-->
                            <th class="text-center text-nowrap">عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in reports">

                            <td class="text-center">{{item.combineNumber}}</td>
                            <td class="text-center">{{item.combinecount}}</td>
                            <td class="text-center">{{item.fvoucherDate}}</td>
                            <td class="text-center">{{item.userFullName}}</td>
                            <td class="text-center">{{item.voucherNumber}}</td>
                            <!--<td class="text-center">{{item.description}}</td>-->
                            <!--<td class="text-center">{{item.price.toLocaleString()}}</td>-->
                            <td class="text-center">
                                <button class="btn btn-danger" @click="printItem(index,item)" title="پرینت لیست ادغام"><i class="fa fa-print"></i></button>
                                <button class="btn btn-danger" @click="editItem(index)" title="ویرایش لیست ادغام"><i class="fa fa-list-alt"></i></button>
                                <button class="btn btn-danger" @click="editNumberItem(item)" title="ویرایش شماره ادغام"><i class="fa fa-list-ol"></i></button>
                                <button class="btn btn-danger" @click="deleteItem(item)" title="حذف اسناد ادغام"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12">
                <div v-if="vouchers === undefined|| vouchers.length===0" class="col-lg-12 text-center mt-5 mb-3">
                    <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
                </div>
                <div v-if="vouchers !== undefined && vouchers.length < dataCount" class="col-lg-12 text-center my-3">
                    <button class="btn btn-success" @click="getTransactions">نمایش اسناد بیشتر
                        ({{vouchers.length}}/{{dataCount}})
                    </button>
                    <div class="col-2 offset-5 my-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تعداد نمایش</span>
                            </div>
                            <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="editNumber" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">تغییر شماره سند ادغام</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <span class="text-center w-100 p-3">شمار جدید سند ادغام را وارد کنید</span>
                    <div class="input-group p-5">
                        <div class="input-group-prepend">
                            <span class="input-group-text">شمار جدید</span>
                        </div>
                        <input class="form-control" type="number"
                               v-model="newNumber" placeholder="شماره جدید سند">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onConfirmationModalOk">تایید</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="printItem" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 1140px;" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5>لیست ادغام شماره
                            {{oldNumber}}
                        </h5>
                    </div>
                    <div class="modal-body" id="printMe">
                        <div class="w-100 text-center">
                            <span class="text-center text-bold">سند ادعام شماره :
                                {{combineNumber}}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <span class="text-center text-bold">تاریخ :
                                {{fCombineDate}}</span>

                        </div>
                        <div class="table-responsive" v-if="journals !== undefined && journals.length>0">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <!--<th class="text-center text-nowrap">شماره سند ادغام</th>-->
                                    <!--<th class="text-center text-nowrap">تاریخ</th>-->
                                    <th class="text-center text-nowrap">عنوان حساب</th>
                                    <!--<th class="text-center text-nowrap">زیر سرفصل</th>-->
                                    <th class="text-center text-nowrap">توضیحات</th>
                                    <th class="text-center text-nowrap">مبلغ جزیی</th>
                                    <th class="text-center text-nowrap">جمع بدهکار</th>
                                    <th class="text-center text-nowrap">جمع بستانکار</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in journals">

                                    <!--<td class="text-center">{{index ===0 ? combineNumber : ""}}</td>-->
                                    <!--<td class="text-center">{{index ===0 ? fCombineDate : ""}}</td>-->
                                    <td class="text-center" :class="item.outSourceName === '' ? 'text-bold' : ''">{{item.outSourceName === "" ? item.parentOutSourceName : item.outSourceName}}</td>
                                    <!--<td class="text-center">{{item.outSourceName}}</td>-->
                                    <td class="text-center">{{item.description}}</td>
                                    <td class="text-center">{{item.joz.toLocaleString()}}</td>
                                    <td class="text-center" :class="item.outSourceName === '' ? 'text-bold' : ''">{{item.outSourceName !== "" ? 0 :item.debtor .toLocaleString()}}</td>
                                    <td class="text-center" :class="item.outSourceName === '' ? 'text-bold' : ''">{{item.outSourceName !== "" ? 0 :item.creditor .toLocaleString()}}</td>
                                </tr>
                                <tr>
                                    <td class="text-center" colspan="3">جمع کل :</td>
                                    <td class="text-center text-bold">{{totalDebt.toLocaleString()}}</td>
                                    <td class="text-center text-bold">{{totalCreat.toLocaleString()}}</td>

                                </tr>
                                </tbody>

                            </table>
                        </div>
                        <h5 class="w-100 text-center" v-else>هیچ سندی پیدا نشد</h5>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button class="d-inline-block btn btn-info m-1" title="دانلود خروجی اکسل">
                            <export-excel
                                    :data="excelVoucher"
                                    :fields="excelHeaders"
                                    :name="filename"
                                    :title="exceltitle"
                                    :footer="excelFooter"

                            >

                                <i class="fa fa-file-excel-o"></i>
                            </export-excel>
                        </button>
                        <button type="button" class="btn btn-info mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';
    import excel from 'vue-excel-export'

    Vue.use(excel)
    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'accountCobine',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                printVoucher: [],
                journals: [],
                printJournals: [],
                newNumber: 0,
                oldNumber: 0,

                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    name: 0,
                },
                vouchers: [],
                reports: [],
                dataCount: 0,
                isSending: false,
                isWaiting: false,
                totalDebt: 0,
                totalCreat: 0,
                combineNumber: 0,
                fCombineDate: "",

                filename: "گزارش سند ادغام",
                exceltitle:[],
                excelFooter: [],
                excelHeaders: {
                    'سرفصل حساب': 'parentOutSourceName',
                    'عنوان حساب': 'outSourceName',
                    'توضیحات': 'description',
                    'مبلغ جزیی': 'joz',
                    'بدهکار': 'debtor',
                    'بستانکار': 'creditor',
                },
                excelVoucher:[],
            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);


            this.getTransactions(-1);
        },
        methods: {
            changePageSize(e) {
                this.getTransactions(-1);
            },
            getTransactions(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('voucher', '/GetCombine').getList(this.queryParams).then(response => {
                    this.reports = [];
                    this.vouchers.push.apply(this.vouchers, response.data.data);
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherReport[0].fvoucherDate = Moment(item.voucherReport[0].voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        item.voucherReport[0].combinecount = item.voucherReport.length;
                        this.reports.push(item.voucherReport[0]);
                    }
                }).catch(error => {
                    $("#loading").hide();
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
                // new BaseService('account','/getPaymentList').getList().then(response => {
                //      console.log(response)
                // }).catch(error => {
                //     this.isSending = false;
                //     Utils.handleErrorWithNotification(error.data.message, this.$noty);
                // });
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            onConfirmationModalOk() {
                if (this.newNumber === 0) {
                    this.$noty.error("لطفا یک شماره بجز 0 وارد کنید.");
                } else {
                    new BaseService(`voucher/UpdateCombineNumber/${this.oldNumber}/${this.newNumber}`).update().then(response => {
                        this.$noty.success("شماره سند با موفقیت ویرایش شد.");
                        $("#editNumber").modal('hide');
                        this.getTransactions(-1);
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            editNumberItem(i) {
                this.newNumber = 0;
                this.oldNumber = i.combineNumber;
                $("#editNumber").modal('show');
            },
            printItem(index, it) {
                let item = this.vouchers[index];
                this.newNumber = 0;
                this.oldNumber = item.combineNumber;
                // this.printVoucher = item.voucherReport;
                this.combineNumber = item.combineNumber;
                this.fCombineDate = it.fvoucherDate;
                this.printVoucher = [];
                this.printVoucher.push.apply(this.printVoucher, item.voucherReport);
                this.journals = [];
                // this.processVoucher();
                this.filename= "گزارش سند ادغام شماره " +  this.combineNumber;
                this.exceltitle.push( "سند ادغام شماره : " + this.combineNumber + " تاریخ : " +  this.fCombineDate);
                new BaseService('voucher', `/GetCombineVoucherJournals/${this.combineNumber}`).getList().then(response => {
                    if (response.data.journals.length > 0) {
                        this.journals = response.data.journals;
                        for (let i of this.journals) {
                            if(i.outSourceName === ''){
                                i.joz = 0;
                                this.totalDebt =+i.debtor;
                                this.totalCreat=+i.creditor;
                            }else{
                                i.joz = i.debtor + i.creditor;
                                i.debtor=0;
                                i.creditor=0;
                            }
                        }
                        this.excelVoucher =this.journals;
                        let a = {
                            parentOutSourceName:"",
                            description:"",
                            joz:0,
                            outSourceName: "جمع کل :",
                            debtor:this.totalDebt,
                            creditor:this.totalCreat,
                        };
                        this.excelVoucher.push(a);
                        // this.excelFooter.push("جمع کل :");
                        // this.excelFooter.push("جمع بدهکار : " + this.totalDebt.toLocaleString() + " جمع بستانکار : " + this.totalCreat);
                        $("#printItem").modal('show');
                    }
                    // this.journals.push(response.data.journals)
                    // this.journals.push.apply(this.journals, response.data.journals);
                    this.isWaiting = false;
                    this.isSending = false;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                    this.isWaiting = false;
                    this.isSending = false;
                });
            },
            async processVoucher() {
                for (let i = 0; i < this.printVoucher.length; i++) {
                    // منتظر بمانید تا درخواست قبلی تمام شود
                    await this.processVoucherJournal(this.printVoucher[i].id);
                }
                setTimeout(() => {

                    this.printJournals = [];
                    try {
                        for (let i of this.journals) {
                            let fp = false;
                            for (let j of this.printJournals) {
                                if (i.journalId === j.journalId) {
                                    fp = true;
                                }
                            }
                            if (fp) {

                            } else {

                                this.printJournals.push(i);
                                this.printJournals.push(i);
                                // console.log(this.printJournals)
                                // for (let k of this.printJournals) {
                                //     if (k.journalId === i.journalId && k.foutSourceName !== "") {
                                //         k.foutSourceName = k.outSourceName;
                                //         k.totcreditor =0;
                                //         k.totdebtor =0;
                                //         k.joz = k.debtor+ k.creditor;
                                //         k.fparentOutSourceName = "";
                                //     }
                                // }
                                // if (i.parentOutSourceName !== i.outSourceName) {
                                //     for (let h of this.journals) {
                                //         if (i.parentOutSourceName === h.parentOutSourceName && i.journalId !== h.journalId) {
                                //             h.parentOutSourceName = "";
                                //             h.foutSourceName = h.outSourceName;
                                //             h.joz = h.debtor+ h.creditor;
                                //             this.printJournals.push(h);
                                //             for (let k of this.printJournals) {
                                //                 if (k.journalId === i.journalId && k.foutSourceName === "") {
                                //                     k.totcreditor += h.creditor;
                                //                     k.totdebtor += h.debtor;
                                //                 }
                                //             }
                                //         }
                                //     }
                                // }
                            }
                        }
                        console.log(this.printJournals)
                        $("#printItem").modal('show');
                    } catch (e) {
                        console.log(e)

                    }
                }, 2000);
                // const result = this.processData(this.journals);

                // نمایش نتیجه


            },
            processData(data) {

                try {
                    const grouped = {}; // متغیر برای ذخیره گروه‌بندی

                    // استفاده از حلقه for برای پردازش داده‌ها
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i];
                        const key = item.parentOutSourceName; // کلید گروه‌بندی

                        console.log("Processing item: ", item);
                        console.log("Key: ", key);

                        if (!key) {
                            console.error("Missing parentOutSourceName in item: ", item); // بررسی داده‌های نامعتبر
                            continue;
                        }

                        if (!grouped[key]) {
                            grouped[key] = {items: [], totalDebtor: 0, totalCreditor: 0}; // مقداردهی اولیه گروه
                        }

                        grouped[key].items.push(item); // افزودن آیتم به گروه
                        grouped[key].totalDebtor += item.debtor; // جمع بدهکار
                        grouped[key].totalCreditor += item.creditor; // جمع بستانکار

                        console.log("Grouped so far: ", grouped); // نمایش وضعیت گروه‌بندی
                    }


                    console.log("Grouped result: ", grouped);  // نمایش نتیجه گروه‌بندی

                    // تبدیل به آرایه و مرتب‌سازی
                    const result = Object.keys(grouped).map(parentName => ({
                        parentOutSourceName: parentName,
                        totalDebtor: grouped[parentName].totalDebtor,
                        totalCreditor: grouped[parentName].totalCreditor,
                        items: grouped[parentName].items
                    }));

                    console.log("Result before sorting: ", result);  // نمایش نتیجه قبل از مرتب‌سازی

                    // مرتب‌سازی بر اساس parentOutSourceName
                    return result.sort((a, b) =>
                        a.parentOutSourceName.localeCompare(b.parentOutSourceName)
                    );
                } catch (e) {
                    console.log(e)

                }
            },
            async processVoucherJournal(id) {
                this.isSending = true;
                try {
                    new BaseService('voucher', `/GetVoucherJournals/${id}`).getList().then(response => {
                        if (response.data.journals.length > 0) {
                            for (let i of response.data.journals) {
                                this.journals.push(i);
                            }
                        }
                        // this.journals.push(response.data.journals)
                        // this.journals.push.apply(this.journals, response.data.journals);
                        this.isWaiting = false;
                        this.isSending = false;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                        this.isWaiting = false;
                        this.isSending = false;
                    });
                } catch (error) {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                } finally {
                    this.isSending = false;
                }
            },


            editItem(i) {
                this.$router.push(
                    {
                        name: 'addCombine',
                        params: {
                            vouchers: this.vouchers[i].voucherReport,
                            combineNumber: this.vouchers[i].combineNumber
                        }
                    }
                );
            },
            deleteItem(i) {
                if (confirm("آیا حذف شماره ادغام اسناد را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteCombine/${i.combineNumber}`).create().then(response => {
                        this.$noty.success('شماره ادغام سند با موفقیت حذف شد');
                        this.getTransactions(-1);
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            newClicked() {
                this.$router.push({name: 'addCombine',});
            },


        },

        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#payment").hasClass("show")) {
                $("#payment").modal("hide");
                next(false);
            } else {
                if ($("#check").hasClass("show")) {
                    $("#check").modal("hide");
                    next(false);
                } else {
                    if ($("#customer").hasClass("show")) {
                        $("#customer").modal("hide");
                        next(false);
                    } else {
                        if ($("#transaction").hasClass("show")) {
                            $("#transaction").modal("hide");
                            next(false);
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>